// src/components/ui/Check.tsx — checkbox row that fills with brass.
//
// Optional `sub` prop renders a muted second line under the label. Used by
// the apps grid in AccessUserEditPage to clarify what each per-app toggle
// actually does (e.g. firstAider: "See who's a first aider"). When `sub`
// is omitted the component renders exactly as before — single-line label
// only — so existing call-sites (the Roles grid, account-status, etc.) are
// unaffected.
import { C, F } from "../../theme";

export interface CheckProps {
  label: string;
  checked: boolean;
  onToggle: () => void;
  disabled?: boolean;
  sub?: string;
}

export const Check = ({ label, checked, onToggle, disabled, sub }: CheckProps) => (
  <label
    style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "10px 12px",
      borderRadius: 10,
      background: checked ? C.brassBg : C.paperWarm,
      cursor: disabled ? "not-allowed" : "pointer",
      border: `1px solid ${checked ? C.brassLt : "transparent"}`,
      opacity: disabled ? 0.6 : 1,
    }}
  >
    <div
      style={{
        width: 22,
        height: 22,
        borderRadius: 6,
        background: checked ? C.brassDk : C.card,
        border: `2px solid ${checked ? C.brassDk : C.hairline}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {checked && (
        <span style={{ color: C.brassGlow, fontSize: 13, fontWeight: 900, lineHeight: 1 }}>
          {"\u2713"}
        </span>
      )}
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1, minWidth: 0 }}>
      <span style={{ fontFamily: F.body, fontSize: 14, fontWeight: 700, color: C.ink }}>{label}</span>
      {sub && (
        <span
          style={{
            fontFamily: F.body,
            fontSize: 11,
            fontWeight: 500,
            color: C.inkMute,
            lineHeight: 1.3,
          }}
        >
          {sub}
        </span>
      )}
    </div>
    <input
      type="checkbox"
      checked={checked}
      onChange={onToggle}
      disabled={disabled}
      style={{ display: "none" }}
    />
  </label>
);
